import { render, staticRenderFns } from "./DashboardLayoutAXB_1.vue?vue&type=template&id=df77c1ca&scoped=true&"
import script from "./DashboardLayoutAXB_1.vue?vue&type=script&lang=js&"
export * from "./DashboardLayoutAXB_1.vue?vue&type=script&lang=js&"
import style0 from "./DashboardLayoutAXB_1.vue?vue&type=style&index=0&id=df77c1ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df77c1ca",
  null
  
)

export default component.exports